

import {  useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import {  toast } from "react-toastify";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import apiService from "../api/ApiService";
import { addComments } from "../redux/slices/commentsSlice";
import { Category, Close, Title } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { isEqual } from "./EditModalDam";
const moment=require('moment-jalaali');


const EditComment=({selected,flag,types,iindex})=>{
    const {currentComments}=useSelector(state=>state.comments);
    const [valid,setValid]=useState(false)

    const dispatch=useDispatch()
    const mainProp={title:selected?.title,comment:selected?.comment,
    ...(flag=='sensor'&&{"type": selected?.sensorCommentTypeId}),
    ...(flag=='cattle'&&{"type": selected?.cattleCommentTypeId}),
    ...(flag=='cattles'&&{"type": selected?.cattleCommentTypeId}),
    ...(flag=='pens'&&{"type": selected?.penCommentTypeId}),
    ...(flag=='farm'&&{"type": selected?.farmCommentTypeId})
}
    const {closeEditModallComment,isModalEditCommentOpen,openEditModallComment}=useGlobalContext();
    const {watch,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({
        defaultValues:mainProp
      });
    
   
    const editCattleComm=async(dataa)=>{
       
        const {comment,type,title}=dataa
            const data=JSON.stringify({
                "title": title,
                "comment": comment,
                "cattleCommentTypeId": type
              })
            const res=await apiService.updateCattleComment(selected.id,data);
            const editedList = [
              ...currentComments.slice(0,iindex),
              res.data,
              ...currentComments.slice(iindex+1)
            ];
            dispatch(addComments([...editedList]))
            openEditModallComment()

       
    }
    const editsSensorComment=async(dataa)=>{
        const {comment,type,title}=dataa
            const data=JSON.stringify({
                "title": title,
                "comment": comment,
                "sensorCommentTypeId": type
              })
            const res=await apiService.updateSensorComment(selected.id,data);
            const editedList = [
              ...currentComments.slice(0,iindex),
              res.data,
              ...currentComments.slice(iindex+1)
            ];
            dispatch(addComments([...editedList]))
            openEditModallComment()
    }
    const editPenComment=async(dataa)=>{
        const {comment,type,title}=dataa
            const data=JSON.stringify({
                    "title": title,
                    "comment": comment,
                    "penCommentTypeId": type
                  
              })
            const res=await apiService.updatePenComment(selected.id,data);
            const editedList = [
              ...currentComments.slice(0,iindex),
              res.data,
              ...currentComments.slice(iindex+1)
            ];
            dispatch(addComments([...editedList]))
            openEditModallComment()
    }
    const editFarmComment=async(dataa)=>{
        const {comment,type,title}=dataa
            const data=JSON.stringify({
                "farmIds": [
                  "string"
                ],
                "title": title,
                "comment": comment,
                "farmCommentTypeId": type
              })
            const res=await apiService.editFarmComment(selected.id,data);
            const editedList = [
              ...currentComments.slice(0,iindex),
              res.data,
              ...currentComments.slice(iindex+1)
            ];
            dispatch(addComments([...editedList]))
            openEditModallComment()
    }
  const allData=watch();
  useEffect(()=>{
    setValid(isEqual(mainProp,allData))
  },[allData])

    return <div onClick={closeEditModallComment} className={`modal-overlay ${isModalEditCommentOpen&&'show-modal'} `}>
        <form onSubmit={handleSubmit((flag==='cattle'||flag==='cattles')?editCattleComm:(flag==='sensor'?editsSensorComment:(flag=='pens'?editPenComment:editFarmComment)))} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <DriveFileRenameOutlineIcon fontSize="large"/>

            <h4 >   یادداشت</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("title",{
              required: 'این مقدار ضروری است',pattern:{
                value:/.{1,100}/,
                message:'فقط 100 کاراکتر'
              }
            })}/>
            <label for="" className={'labelSS'}><Title fontSize="small"/> موضوع </label>
            {errors?.title?.message&&<span className='errMsg'>{errors?.title?.message}</span>}
        </div>
        <div className="SelConn">
        <label for='sele' ><Category fontSize="small"/> دسته:</label>
        <select  id='sele'  name='sele' className="selectInp" {...register("type",{
              required: 'این مقدار ضروری است'
            })}>
            {types?.map((item,index)=>{
                return <option key={index} value={item.id}>{item.title}</option>
            })}
        </select>
        {errors?.type?.message&&<span className='errMsg'>{errors?.type?.message}</span>}
        </div>
        <div className='inputContainerSS2'>
            <textarea autoComplete="off" type="text"  
             className='inputSS inputSSText2' placeholder="a" {...register("comment",{
                required: 'این مقدار ضروری است',pattern:{
                  value:/.{1,1000}/,
                  message:'فقط 1000 کاراکتر'
                }
              })}/>
            <label for="" className={'labelSS labelText'}>متن</label>
            {errors?.comment?.message&&<span className='errMsg'>{errors?.comment?.message}</span>}
        </div>
        
       <button disabled={valid} className="EditMOdalBtnForm" type="submit">
            به روز رسانی
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
       
        </div>
        
    </div>
}
export default  EditComment